export const MuiDialogActions = {
  styleOverrides: {
    root: {
      '& > :not(:first-of-type)': {
        marginLeft: '16px',
      },
    },
  },
};
